import React from 'react';
import { Button } from '@economic/taco';
import { Trans } from '@lingui/macro';
import ConfirmSubscriptionChangeDialog from '../ConfirmSubscriptionChangeDialog';

export default function PackageCardButtons({
    disabledReason,
    highlighted,
    isTrialUpgrade,
    header,
    planId,
    isDowngrade,
    readMoreLink,
    disabled,
    redirectToSubscriptionStatusPage = true,
}: {
    disabledReason?: string | undefined;
    highlighted: boolean;
    isTrialUpgrade: boolean;
    header: string;
    planId: number;
    isDowngrade: boolean;
    readMoreLink: string | undefined;
    disabled: boolean;
    redirectToSubscriptionStatusPage?: boolean;
}) {
    return (
        <div className="flex justify-center pb-3 px-4">
            {disabledReason ? (
                <div className="text-xs text-center italic">{disabledReason}</div>
            ) : highlighted ? (
                !isTrialUpgrade ? (
                    <Button disabled appearance="primary" className="flex-grow">
                        <Trans>Current plan</Trans>
                    </Button>
                ) : (
                    <Button
                        appearance="primary"
                        className="flex-grow"
                        dialog={dialogProps => (
                            <ConfirmSubscriptionChangeDialog
                                modalProps={dialogProps}
                                planName={header}
                                planId={planId}
                                isDowngrade={isDowngrade}
                                isTrialUpgrade={isTrialUpgrade}
                                readMoreLink={readMoreLink}
                                redirectToSubscriptionStatusPage={redirectToSubscriptionStatusPage}
                            />
                        )}>
                        <Trans>Select suggested</Trans>
                    </Button>
                )
            ) : disabled /* If no disabledReason has been provided just disable the button */ ? (
                <Button disabled appearance="primary" className="flex-grow">
                    <Trans>Select plan</Trans>
                </Button>
            ) : (
                <Button
                    appearance="primary"
                    className="flex-grow"
                    dialog={dialogProps => (
                        <ConfirmSubscriptionChangeDialog
                            modalProps={dialogProps}
                            planName={header}
                            planId={planId}
                            isDowngrade={isDowngrade}
                            isTrialUpgrade={isTrialUpgrade}
                            readMoreLink={readMoreLink}
                            redirectToSubscriptionStatusPage={redirectToSubscriptionStatusPage}
                        />
                    )}>
                    <Trans>Select plan</Trans>
                </Button>
            )}
        </div>
    );
}
